import { Box, Flex } from '@chakra-ui/react'
import StaticDsrHeader from './StaticDsrHeader'
import DsrGenericErrorModal from './DsrGenericErrorModal'
import { memo, useEffect, useRef, useState } from 'react'
import RenderStaticDsrContent from './RenderStaticDsrContent'
import { useParams } from 'react-router-dom'
import { generateSessionId, generateRandomString } from '../../global/helpers/global-helpers'
import { sendToGA } from '../../global/helpers/google-tag-helpers'
import { checkIsLoggedInUser } from '../../auth/helpers/auth-checker'

import { useLocation, useHistory } from 'react-router-dom';
import PageLoader from '../../global/components/helper-components/components/PageLoader'
import appConfig from '../../../config/app-config'
import LaunchdeckBrandingLabel from '../../global/components/product-marketing/LaunchdeckBrandingLabel'
import useLaunchdeckModal from '../../global/hooks/use-launchdeck-modal'

const StaticDsrDisplayPage = ({
  dsrConfiguration,
  dsrStatusRedux,
  dsrTeamMembersRedux,
  dsrPropertiesRedux,
  fetchPublicDsrData,
  dsrInvalidRequestRedux,
  logGuestDsrAnalytics,
  isMobileView,
}) => {
  const { dsrId } = useParams()
  const location = useLocation();
  const history = useHistory();
  const { openLaunchdeckModal } = useLaunchdeckModal();

  const initRef = useRef(false);
  const initRoomSettingsRef = useRef(false)
  const analyticsRef = useRef(false);
  const [sessionId, setSessionId] = useState(null)
  const [userId, setUserId] = useState("")
  const [showRoomLoadingState, setShowRoomLoadingState] = useState(true)
  const [isLoggedInUser, setIsLoggedInUser] = useState("")
  const headerMenuHeight = isMobileView ? '170px' : '70px';


  // Page Setup
  useEffect(() => {
    if (!initRef.current && dsrId !== 'new') {
      document.title = 'Launchdeck Digital Sales Room'
      document.description =
        'Create customised private digital sales rooms that let Sales & Purchasing teams agree on deals quickly'

      const isLoggedInUser = checkIsLoggedInUser();
      setIsLoggedInUser(isLoggedInUser)

      const { publicViewsAllowed, authProcess, authProcessSuccess, showMemberedRoom } = location.state || {};
    
      if ((publicViewsAllowed === true) || (!publicViewsAllowed && authProcess === "access-code-challenge" && authProcessSuccess === true)) {
        if (isLoggedInUser === true && authProcess !== "confirm-public-dsr-access" && showMemberedRoom) {
          
          history.push(`/dsr/${dsrId}`, {})
        } else {
       
          fetchPublicDsrData(dsrId)

          const generatedSessionId = generateSessionId()
          setSessionId(generatedSessionId)

          // GA4
          const tempUserIdToken = 'pub-visitor__' + generateRandomString(8)
          setUserId(tempUserIdToken)

          sendToGA('view_dsr', {
            'eventTimestamp': new Date().toISOString(),
            'dsrId': dsrId,
            'userIdToken': userId
          });
        }
      } else {

        if (!authProcess) {
          // URL hacking scenario
          history.push(`/dsr/access/${dsrId}`, {})
        } else {
          // Random error has occured
          history.push(`/page-not-found`, {
            redirectionUri: appConfig.landingPage
          })
        }
      }

      initRef.current = true
    }
  }, [dsrId, fetchPublicDsrData]) // fetchPublicDsrData is a new end point to get non sensitive data

  // Analytics
  useEffect(() => {
    if (!analyticsRef.current) {
      logGuestDsrAnalytics({
        eventType: 'guest-enters-dsr',
        analyticsPayload: {
          userId: userId,
          dsrId,
          sessionId: sessionId
        }
      })

      analyticsRef.current = true
    }

  }, [])

  // Business Logic
  useEffect(() => {
    if (
      // (currentDsrId === dsrId) && 
      initRef.current && (dsrInvalidRequestRedux === true)) {

      history.push(`/page-not-found`, {
        redirectionUri: appConfig.landingPage
      })
    }

    if (dsrStatusRedux) {
      switch (dsrStatusRedux) {
        case ("reverted-draft"):
        case ("draft"): {
          history.push(`/page-not-found`, {
            redirectionUri: appConfig.landingPage
          })

          break;
        }
        default: {
          setShowRoomLoadingState(false)
          // Do not put any response here (activated while page is loading)
          break;
        }
      }

    }


  }, [dsrId, dsrInvalidRequestRedux, dsrStatusRedux])

  // Apply Room settings
  useEffect(()=> {
    if (dsrPropertiesRedux && !initRoomSettingsRef.current && location.state) {
      const {roomSettings} = dsrPropertiesRedux || {}
      
      const {accessCodeProtected, showJoinRoomReminder} = roomSettings || {};
      
      if (accessCodeProtected) {
        const {accessAuth} = location.state || {}
        if (!accessAuth) {
          history.push(`/dsr/access/${dsrId}`, {})
        }
      } else if (!!showJoinRoomReminder) {
        if (isLoggedInUser) {
          openLaunchdeckModal("show-add-logged-in-user-prompt")
        } else {
          openLaunchdeckModal("show-signup-login-prompt")
        }
      }

      initRoomSettingsRef.current = true
    }
  }, [dsrPropertiesRedux, location.state])
  
  return (
    <Flex direction="column" height='100%'>
      <Flex direction="row" flexGrow="1">
        {showRoomLoadingState ?
          <PageLoader />
          :
          <Flex w="100%" direction="column" alignItems="center" bg="white">
            <Box width='100%' position='fixed' zIndex='2'>
              <StaticDsrHeader
                dsrTeamMembers={dsrTeamMembersRedux}
                isLoggedInUser={isLoggedInUser}
                dsrPropertiesRedux={dsrPropertiesRedux}
              />
            </Box>

            <Flex w="100%" className="authentication-container" justify="center" pt={headerMenuHeight} bg={'#F4F4F4'}>
              <RenderStaticDsrContent
                dsrId={dsrId}
                sessionId={sessionId}
                dsrConfiguration={dsrConfiguration}
              />
              <DsrGenericErrorModal dsrId={dsrId} />
            </Flex>
            <LaunchdeckBrandingLabel />
          </Flex>
        }
      </Flex>
    </Flex>
  )


}

export default memo(StaticDsrDisplayPage)
